import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const SummaryInlineDisplay = () => {
  return (
    <Box
      sx={() => ({
        width: "100%",
        background: "#45454515",
        border: "1px solid #45454545",
        borderRadius: "15px",
        p: 2,
      })}
    >
      <Typography>
        <b>Summary</b>
        <Box sx={{ mt: 1 }}>
          {[1, 2, 3, 4].map((line) => (
            <Box
              key={line}
              sx={{
                height: 12,
                width: `${80 - line * 10}%`,
                backgroundColor: "#e0e0e0",
                borderRadius: 1,
                mb: line !== 4 ? 1 : 0,
              }}
            />
          ))}
        </Box>
      </Typography>
    </Box>
  );
};
